import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import classes from "./panel-scss.js";
const Panel = ({ children, dataHook, ...props }) => {
  const { isMobile, environment } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    SidePanel,
    {
      width: isMobile ? "100%" : 288,
      height: isMobile ? "100vh" : "fit-content",
      ...props,
      dataHook: classNames("floating-layout-root", dataHook),
      skin: "floating",
      className: classNames(classes.modal, { [classes.liveSite]: environment === "liveSite" })
    },
    children
  );
};
export {
  Panel
};
//# sourceMappingURL=panel.js.map
